module.exports = __webpack_public_path__ + "media/images/pic/brodno/people/marika-21d42ebd77b22c35745d82502aa4e8d6.webp";